import { useStore } from "effector-react";
import { $flags } from "./models";

export const useFlags = () => {
  return useStore($flags);
};
